import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { ConstantsService } from '../common/services/constants.service';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json;charset=utf-8', 
        'Authorization': ConstantsService.AUTH_TOKEN
    })    
};


@Injectable()
export class PhotoauthService {

    constructor(private http: HttpClient) { }

    photosave(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, files:any, exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'student/uploadbase64', {usercode: usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, file:files, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }


    photoid(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, files:any, exam_id: number):Observable<any> {
        return this.http.post<any>(rootUrl+'student/uploadbase64Idcard', {usercode: usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, files:files, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }
    facerec(rootUrl:string, usercode: string, student_id:number, exam_id: number, profilepic: string, theory2: number, psycho: number,adaptive: number,theory3: number):Observable<any> {
        if(theory2 == 1)
        {
          return this.http.post<any>(rootUrl+'exam/theorySecond/fr', {usercode: usercode, student_id:student_id, exam_id:exam_id, profile_pic:profilepic}, httpOptions)
                .pipe(map(response => {
                    return response;
                }));
        } 
        else if(psycho == 1)
        {
          return this.http.post<any>(rootUrl+'exam/psyc/fr', {usercode: usercode, student_id:student_id, exam_id:exam_id, profile_pic:profilepic}, httpOptions)
                .pipe(map(response => {
                    return response;
                }));
        } 
        else if(adaptive == 1)
        {
          return this.http.post<any>(rootUrl+'exam/adaptive/fr', {usercode: usercode, student_id:student_id, exam_id:exam_id, profile_pic:profilepic}, httpOptions)
                .pipe(map(response => {
                    return response;
                }));
        }  
        else if(theory3 == 1)
            {
              return this.http.post<any>(rootUrl+'exam/theory3/fr', {usercode: usercode, student_id:student_id, exam_id:exam_id, profile_pic:profilepic}, httpOptions)
                    .pipe(map(response => {
                        return response;
                    }));
            }                
        else
        {
          return this.http.post<any>(rootUrl+'student/fr/initiate', {usercode: usercode, student_id:student_id, exam_id:exam_id, profile_pic:profilepic}, httpOptions)
              .pipe(map(response => {
                  return response;
              }));
        }
    }
/*    checkPhotoAuth(rootUrl:string, usercode: string, userid:number, subuserid:number, exam_id: number, auth_type:string):Observable<any> {
        return this.http.post<any>(rootUrl+'student/privilage', {usercode: usercode, user_id:userid, sub_user_id:subuserid, exam_id:exam_id, auth_type:auth_type}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }*/
      /** 
   *  upload-myprofile-Webphoto
   */
   studentWebImage(rootUrl: string,id_self_student:number,file:any): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/updateProfilePicWeb', {id_self_student: id_self_student,file:file}, httpOptions)
          .pipe(map(user => {
              return user;
          }));
  }

     /** 
   *  upload-myprofile-Webphoto
   */
    studentfacerec(rootUrl: string,id_student:number,file:any): Observable<any> {
        return this.http.post<any>(rootUrl + 'student/updateProfilePicWeb', {id_student: id_student,file:file}, httpOptions)
          .pipe(map(user => {
              return user;
          }));
  }


      /** 
   *  upload-myprofile-image
   */
   studentprofileImage(rootUrl: string,id_self_student:number,file:any): Observable<any> {
        return this.http.post<any>(rootUrl + 'studentSelf/updateProfilePicWeb', {id_self_student: id_self_student,file:file}, httpOptions)
          .pipe(map(user => {
              return user;
          }));
  }  
  photoid2web(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, files:any, exam_id: number):Observable<any> {
      return this.http.post<any>(rootUrl+'exam/theorySecond/uploadIdCardWeb', {usercode: usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, file:files, exam_id:exam_id}, httpOptions)
          .pipe(map(response => {
              return response;
          }));
  }
  photosave2web(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, files:any, exam_id: number):Observable<any> {
      return this.http.post<any>(rootUrl+'exam/theorySecond/uploadImageWeb', {usercode: usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, file:files, exam_id:exam_id}, httpOptions)
          .pipe(map(response => {
              return response;
          }));
  } 
  photoidPsychoweb(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, files:any, exam_id: number):Observable<any> {
      return this.http.post<any>(rootUrl+'exam/psyc/uploadIdCardWeb', {usercode: usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, files:files, exam_id:exam_id}, httpOptions)
          .pipe(map(response => {
              return response;
          }));
  } 
  photoidAdaptiveweb(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, files:any, exam_id: number):Observable<any> {
      return this.http.post<any>(rootUrl+'exam/adaptive/uploadIdCardWeb', {usercode: usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, file:files, exam_id:exam_id}, httpOptions)
          .pipe(map(response => {
              return response;
          }));
  }   
  photoidTheory3web(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, files:any, exam_id: number):Observable<any> {
    return this.http.post<any>(rootUrl+'exam/theory3/uploadIdCardWeb', {usercode: usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, file:files, exam_id:exam_id}, httpOptions)
        .pipe(map(response => {
            return response;
        }));
}   
  photosavePsychoweb(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, files:any, exam_id: number):Observable<any> {
      return this.http.post<any>(rootUrl+'exam/psyc/uploadImageWeb', {usercode: usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, file:files, exam_id:exam_id}, httpOptions)
          .pipe(map(response => {
              return response;
          }));
  } 
  photosaveAdaptiveweb(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, files:any, exam_id: number):Observable<any> {
      return this.http.post<any>(rootUrl+'exam/adaptive/uploadImageWeb', {usercode: usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, file:files, exam_id:exam_id}, httpOptions)
          .pipe(map(response => {
              return response;
          }));
  }  
  photosaveTheory3web(rootUrl:string, usercode: string, userid:number, subuserid:number, student_id:number, files:any, exam_id: number):Observable<any> {
    return this.http.post<any>(rootUrl+'exam/theory3/uploadImageWeb', {usercode: usercode, user_id:userid, sub_user_id:subuserid, student_id:student_id, file:files, exam_id:exam_id}, httpOptions)
        .pipe(map(response => {
            return response;
        }));
}            
}